import RiskProblem from './RiskProblem.vue';

export default RiskProblem;
